import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FestivalProvider } from './context/FestivalContext';
import AppRoutes from './routes';

function App() {
  return (
    <Router>
      <AuthProvider>
        <FestivalProvider>
          <AppRoutes />
        </FestivalProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
